import { Type } from '@angular/core';

// Mode of the form
export enum BuilderMode {
    EDIT = 'EDIT', // editing an existent generated report
    NEW = 'NEW', // new report
    EDIT_FROM_LIST = 'EDIT_FROM_LIST' // editing an existent report from the report list
}

//State of the form
export interface BuilderState {
    builderComponent?: Type<unknown>;
    firstOpening?: boolean;
    id?: string;
    mode?: BuilderMode;
    open?: boolean;
    templateStep?: BuilderTemplate;
}

// State of save
export interface SaveDialogState {
    open: boolean;
    isSaving?: boolean;
    tabId: string | undefined;
    isSaveAs?: boolean;
}

export enum BuilderTemplate {
    CHOOSER = 'CHOOSER',
    BUILDER = 'BUILDER',
    MARKET = 'MARKET'
}
